import { toast } from "react-toastify";
export const ToastType = {
  SUCCESS: "Success",
  WARNING: "Warning",
  ERROR: "Error",
};

export const ToastOptions = {
  position: toast.POSITION.BOTTOM_LEFT,
  autoClose: true,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  rtl: false,
  closeButton: false,
  countDown: 5,
};
